import { ListSkillDevelopmentComponent } from './list-skill-development.component';

export default ListSkillDevelopmentComponent;
